import React from 'react'
import { formatDate } from '../../../../../utils/functions'

const MobilePointsDetails = () => {
	const item = JSON.parse(localStorage.getItem('pointDetails'))
	return (
		<div>
			<div className='mb-5 mt-5'>
				<div class='card container-fluid shadow-card w-95 mb-2 '>
					<div className='row d-flex justify-content-between align-items-center '>
						<div className=' col-8 text-center'>
							<h4 className=' letter-normal text-bold text-black'>
								Shopping Amount <br /> Details
							</h4>
						</div>
						<div className=' col-3 title-card-bg'>
							<img
								className='title-card-image ms-n5'
								src='https://static.vecteezy.com/system/resources/thumbnails/008/854/744/small/rupee-coin-stack-3d-icon-for-finance-or-business-illustration-png.png'
								alt=''
							/>
						</div>
					</div>
				</div>
				<div className='card shadow-card container-fluid w-95 card-body mb-4'>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black text-normal text-black'>Order Date</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{formatDate(item?.dateOfPurchase)}</b>
							</div>
						</div>
					</div>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black text-normal'>Order No</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{item?.orderNo}</b>
							</div>
						</div>
					</div>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black text-normal'>Product Type</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-success fw-normal text-start'>{item?.productType}</b>
							</div>
						</div>
					</div>
					<div className='row mb-0'>
						<div className='col-5'>
							<div>
								<b className='text-black text-normal'>Achieved Date</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{formatDate(item?.dateOfPurchase)}</b>
							</div>
						</div>
					</div>
				</div>
				<h3 className='source-serif-4 text-normal text-black ms-3'>Product Information</h3>
				<div className='card shadow-card container-fluid w-95 card-body mb-3'>
					<div className='row justify-content-center align-items-center'>
						<div className='col-3'>
							<div>
								<img className='w-100' src={`${process.env.REACT_APP_RESOURCE_URL}${item?.productImg}`} alt='' />
							</div>
						</div>
						<div className='col-9'>
							<div className=' lh-1 mb-2'>
								<b className='text-normal text-sm text-black text-wrap'>{item?.productName?.join(', ')}</b>
							</div>
							<div className='row d-flex justify-content-center mb-2'>
								<div className='col-6'>
									<b className='text-black text-md fw-normal text-start'>Quantity : </b>
								</div>
								<div className='col-6'>
									{' '}
									<b className='text-black text-md fw-normal text-start'>1 (Item)</b>
								</div>
							</div>
							<div className='row d-flex justify-content-center mb-0'>
								<div className='col-6'>
									<b className='text-black text-md fw-normal text-start'>Grand Total : </b>
								</div>
								<div className='col-6'>
									{' '}
									<b className='text-black text-md fw-bold text-start'>
										<sup>₹</sup>
										{item?.finalPrice}
									</b>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MobilePointsDetails
